module.exports = __webpack_public_path__ + "static/img/cop_sch_logo7.dd4ec7d1.png";